// Leaving the report editor with an edit not yet saved (HUNT P12, review DESIGN-LOG §40). Pure, so the rules are tested
// without mounting the canvas.

// What the route leave asks, if anything: a save that failed ("unsaved changes"), or one still pending (the 700ms
// autosave window) or in flight ("still saving"). Nothing when everything is saved.
export function leavePrompt(state: { dirty: boolean; saving: boolean; error: string }) {
  if (state.dirty && state.error) return "datox.designer.unsavedLeave" as const
  if (state.dirty || state.saving) return "datox.designer.savingLeave" as const
  return undefined
}

// The canvas's cleanup: an edit that is pending, or was made while a save was in flight (the autosave then never
// rescheduled), is saved once the save in flight is done. `blocked`: read-only, an older revision on screen, a failed
// save, nothing loaded. `changed` re-checks after the save in flight; `save` resolves once the last save has settled.
// Resolves to whether something was left unsaved (the caller says so: its own view is gone by then).
export function saveOnLeave(options: {
  pending: boolean
  dirty: boolean
  blocked: boolean
  inFlight?: Promise<unknown>
  changed: () => boolean
  save: () => Promise<unknown>
  unsaved: () => boolean
}): Promise<boolean> | undefined {
  if (options.blocked || (!options.pending && !options.dirty)) return undefined
  return (options.inFlight ?? Promise.resolve())
    .then(() => (options.changed() ? options.save() : undefined))
    .then(() => options.unsaved(), () => true)
}
